import { CLIENT_PORTAL_BASE_URL } from "common/Constants";

const queryKeys = {
  addEngagement: (queryparams) => ({
    key: `add-engagement`,
    url: `/insyts/engagement?isEmail=${queryparams}`,
  }),
  postEngagementDocument: {
    key: "post-engagement-document",
    url: "/insyts/engagement/document-upload",
  },
  postEngagementDocumentList: {
    key: "post-engagement-category-doc-list",
    url: "/insyts/engagement/category-doc",
  },
  getEngagementDocument: (engagementId) => ({
    key: `get-engagement-document-${engagementId}`,
    url: `/insyts/engagement/document-upload?engagementId=${engagementId}`,
  }),
  updateEngagement: {
    key: "update-engagement",
    url: "/insyts/engagement",
  },
  updateSubcontract: {
    key: "update-engagement",
    url: "/insyts/engagement/subcontractor",
  },
  getEngagements: (queryparams) => ({
    key: "get-engagements",
    url: `/insyts-matter/getcalendarmatter?${queryparams}`,
  }),
  getClientEngagements: {
    key: `get-client-engagements-list`,
    url: `/insyts/clients/engagement`,
  },
  getClientDetailed: (clientId) => ({
    key: `get-client-detailed-${clientId}`,
    url: `/insyts/clients/engagement?clientId=${clientId}&LastEvaluatedKey=0`,
  }),
  getMatterById: (matterId) => ({
    key: `get-matter-${matterId}`,
    url: `/insyts-matter/viewmatter?matterid=${matterId}`,
  }),
  getEngagementCloneByEngagementId: (engagementId) => ({
    key: `get-engagement-clone-${engagementId}`,
    url: `/insyts/engagement/clone-engagement?engagementId=${engagementId}`,
  }),
  getAllClientsList: {
    key: `get-all-clients-list`,
    url: "/insyts-legal/getalllegalclients",
  },
  getAllClientFiltered: {
    key: `get-all-clients-filtered`,
    url: "/insyts/engagementclientlist",
  },
  getClient: (clientId) => ({
    key: `get-client-${clientId}`,
    url: `/insyts-legal/getlegalclientbyid?clientid=${clientId}`,
  }),
  addClientSurvey: (engagementId) => ({
    key: "add-client-survey",
    url: "/insyts-matter/client-survey?engagementId=" + engagementId,
  }),
  addClientSurveyEmail: (matterId) => ({
    key: "add-client-survey",
    url: `/insyts-matter/client-survey?isEmail=true&matterId=${matterId}`,
  }),
  postBillingEmail: {
    key: "add-billing-email",
    url: `/insyts/billing/sendbillingmail`,
  },
  postTimesheet: {
    key: "post-timesheet",
    url: "/insyts/timesheet",
  },
  updateTimesheet: {
    key: "update-timesheet",
    url: "/insyts/timesheet",
  },
  getTimesheet: {
    key: "get-timesheet",
    url: "/insyts/timesheet", // query Param: week, employeeId, status
  },
  getAdminApprovalTimesheet: (weeks) => ({
    key: `get-admin-approval-timesheet-${weeks}`,
    url: "/insyts/timesheet/pending",
  }),
  patchTodo: {
    key: "patch-todo",
    url: "/insyts/engagement/todo-task?updateType=single",
  },
  updateTodo: {
    key: "update-todo",
    url: "/insyts/engagement/todo-task?updateType=multi",
  },
  uploadTodoImage: {
    key: `upload-todo-image`,
    url: `/insyts/engagement/todo-files`,
  },
  getTodoImages: (todoId) => ({
    key: `get-todo-images-${todoId}`,
    url: `/insyts/engagement/todo-files?todoId=${todoId}`,
  }),
  getTodoList: (engagementId) => ({
    key: `get-engagement-todo-list-${engagementId ?? "nothing"}`,
    url: "insyts/engagement/todo",
  }),
  getTodoById: (engagementId, todoId) => ({
    key: `get-todo-${todoId}`,
    url: `insyts/engagement/todo?LastEvaluatedKey=0&engagementId=${engagementId}&todoId=${todoId}`,
  }),
  deleteTodo: (todoId, engagementId) => ({
    key: `delete-todo-${todoId}`,
    url: `insyts/engagement/todo?todoId=${todoId}&engagementId=${engagementId}`,
  }),
  postFilterTodoList: (engagementId) => {
    return {
      key: `post-filter-todo-list`,
      url:
        "insyts/engagement/todo-filter?engagementId=" +
        engagementId +
        "&LastEvaluatedKey=0",
    };
  },
  addTodoObj: {
    key: "add-todo",
    url: "insyts/engagement/todo",
  },
  getActivityLog: (queryparams) => ({
    key: `get-activity-log-${queryparams}`,
    url: `activitylog${queryparams}`,
  }),
  getResourcePlanDataById: (engagementId, queryparams) => ({
    key: `post-resource-${engagementId}`,
    url: `insyts/resource-plan/employee-list${queryparams}`,
  }),
  updateResource: {
    key: "patch-resource",
    url: "insyts/resource-plan",
  },
  getAllocatedResourceList: (weekList) => ({
    key: `post-resource-list-${weekList}`,
    url: `insyts/resource-plan/employee-list`,
  }),
  getResourePlanningList: (weekList) => ({
    key: `post-resource-planning-list-${weekList}`,
    url: `insyts/resource-plan`,
  }),
  getCapacityPlanningList: (weekList) => ({
    key: `post-capasity-planning-list-${weekList}`,
    url: `insyts/resource-plan`,
  }),
  getRoleDataList: (clientId) => ({
    key: `get-role-list`,
    url: `owner-roles/${clientId}`,
  }),
  getPeopleDataList: (clientId) => ({
    key: `get-people-list`,
    url: `add-users/${clientId}`,
  }),
  getLateCheckinReport: (clientId, uniqueId) => ({
    key: `get-latecheckin-report-${uniqueId}`,
    url: `late-checkin-report/${clientId}`,
  }),
  getAbsentReport: (clientId, uniqueId) => ({
    key: `get-absent-report-${uniqueId}`,
    url: `absent-report/${clientId}`,
  }),
  getEarlyCheckoutReport: (clientId, uniqueId) => ({
    key: `get-early-checkout-report-${uniqueId}`,
    url: `earlycheckout-report/${clientId}`,
  }),
  getAllBillList: (engagementId, queryparams) => ({
    key: `get-billlist-${engagementId}`,
    url: `/insyts/billing${queryparams}`,
  }),
  getClaims: (queryparams) => ({
    key: `get-claims-${queryparams}`,
    url: `/insyts/timesheet/claims${queryparams}`,
  }),
  getHolidayList: (clientId) => ({
    key: `get-holiday-list-${clientId}`,
    url: `holiday-list/${clientId}`,
  }),
  getLeaveList: (clientId, payload) => ({
    key: `get-leave-list-${payload}`,
    url: `leave-list/${clientId}`,
  }),
  getEngagementDocumentList: (engagementId, queryparams) => ({
    key: `get-engagement-doc-list-${engagementId}`,
    url: `/insyts/engagement/category-doc${queryparams}`,
  }),
  getEngagementDocumentListId: (docId, queryparams) => ({
    key: `get-engagement-doc-list-${docId}`,
    url: `/insyts/engagement/category-doc/download?${queryparams}`,
  }),
  getBillingById: (queryParams) => ({
    key: `get-billlist-${queryParams}`,
    url: `/insyts/billing?${queryParams}`,
  }),
  getTimeSheetByengagementId: (engagementId) => ({
    key: `get-timeSheet-by-engagementid-${engagementId}`,
    url: `/insyts/timesheet?engagementId=${engagementId}`,
  }),
  postClaimsAttachment: {
    key: `post-claims-timesheet-attachment`,
    url: `/insyts/timesheet/attachment`,
  },
  getAllEnggagements: {
    key: `get-all-engagements`,
    url: `/insyts/engagement`,
  },
  getClientsList: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts/clients`,
  }),
  getActualSummary: (matterId, userId) => ({
    key: `get-claims-${matterId}`,
    url: `/insyts/timesheet/actualsummary?matterId=${matterId}&userId=${userId}`,
  }),
  getActualSummaryToEngagementId: (matterId) => ({
    key: `get-claims-to-${matterId}`,
    url: `/insyts/timesheet/actualsummary?matterId=${matterId}`,
  }),
  postActualSummary: (body) => ({
    key: ["actualSummary", body.matterId, body.userId],
    url: "insyts/timesheet/actualsummary",
    body,
  }),
  addEngagementAppraisal: {
    key: "add-engagement-appraisal",
    url: "/insyts/engagement/appraisal",
  },
  // New Api
  unapprovedTimesheets: {
    key: "unapproved-timesheets",
    url: "/insyts/timesheet/unapproved",
  },
  getBillingApprovals: (page, limit, statusname, userId, managingoffice, financeadmin) => {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    params.append("statusname", statusname);
    params.append("userId", userId);
    if (financeadmin === true) {
      params.append("financeadmin", "true");
      if (managingoffice) {
        params.append("managingoffice", managingoffice);
      }
    }
    return {
      key: `get-billing-approvals-${userId}-${financeadmin ? managingoffice : "non-fa"}`,
      url: `insyts/matter/billing-approval?${params.toString()}`,
    };
  },
  getChargeoutRates: {
    key: "Chargeout",
    url: "settings/configuration",
  },
  getHistoryChargeoutRates: (queryparams) => ({
    key: `Chargeouthistory${queryparams}`,
    url: `settings/history?id=${queryparams}`,
  }),
  getPFAApproval: (queryparams) => ({
    key: `get-pfa-approval`,
    url: `/insyts-matter/getpfaapproval?${queryparams}`,
  }),
  updatePFAApproval: {
    key: `update-pfa-approval`,
    url: `/insyts-matter/updatepfaapproval`,
  },
  getDeclaration: (userId, queryparams) => ({
    key: `declaration/${userId}`,
    url: `declaration/${userId}?${queryparams}`,
  }),
  getRolesList: (clientId) => ({
    key: `get-roles`,
    url: `owner-roles/${clientId}`,
  }),
  getPermissionByName: (clientId, roleId) => ({
    key: `get-roles-${clientId}-${roleId}`,
    url: `permissions/${clientId}/${roleId}`,
  }),
  getMyLeaveList: (clientId, payload) => ({
    key: `get-leave-list/${payload}`,
    url: `leave-list/${clientId}`,
  }),
  getPermissonNameList: (clientId) => ({
    key: `get-roles-${clientId}`,
    url: `permissions/nameList/${clientId}`,
  }),
  getAllDeclaration: (clientId, managingoffice, year) => ({
    key: [
      "alldeclaration",
      clientId,
      managingoffice,
      year
    ],
    url: `/alldeclaration/${clientId}?managingoffice=${managingoffice}&year=${year}`
  }),
  getAllTimesheetReport: (clientId, params) => ({
    key: `get-timesheet-report-${params}`,
    url: `/insytsreport/timesheet-data`,
  }),
  getOnboardingReport: (clientId, params) => ({
    key: `get-onboarding-report-${params}`,
    url: `/insytsreport/onboarding-data`,
  }),
  getEngagementCount: {
    key: `get-all-engagement-count`,
    url: "/insyts/loadengagement",
  },
  getEngagementFilterDropdown: (queryParams) => ({
    key: `get-engagement-filter-dropdown`,
    url: `/insyts-matter/getmatterfilterlist/${queryParams}`,
  }),
  getEngagementFilter: (queryParams) => ({
    key: `get-engagement-filter`,
    url: `/insyts-matter/getmatterfilter/${queryParams}`,
  }),
  getBillingFilterDropdown: (queryParams) => ({
    key: `get-billing-filter-dropdown`,
    url: `/insyts/matter/approval-filterlist/${queryParams}`,
  }),
  getBillingFilter: (queryParams) => ({
    key: `get-billing-filter`,
    url: `/insyts/matter/billingapproval-filter/${queryParams}`,
  }),
  getClientsList: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts-crm-clients`,
  }),
  getAllClientList: {
    key: `get-all-clients`,
    url: `/insyts-legal/getAllClientList`,
  },
  getManagingOffice: () => ({
    key: "get-managing-office",
    url: `/insyts-crm-clients/managing-office`,
  }),

  getClientStatus: () => ({
    key: "get-client-status",
    url: `/insyts-crm-clients/client-status`,
  }),

  getClientOwner: () => ({
    key: "get-client-owner",
    url: `/insyts-crm-clients/client-owner`,
  }),

  getRelationshipManager: () => ({
    key: "get-relationship-manager",
    url: `/insyts-crm-clients/relationship-manager`,
  }),
  getClientIdCount: () => ({
    key: "get-client-id-count",
    url: `/insyts-crm-clients/count`,
  }),
  getClientDetailsById: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts-crm-clients/BDO`,
  }),
  getDashboardEngagement: () => ({
    key: `get-dashboard-engagement`,
    url: `/insyts-user-dashboard/getuserdashboardengagement`,
  }),
  getIndividualSummary: (queryParams) => ({
    key: `get-dashboard-summary`,
    url: `/insyts-user-dashboard/getdashboardsummary${queryParams}`,
  }),
  getTimeSheetData: (queryParams) => ({
    key: `get-timesheet-data`,
    url: `/insyts-user-dashboard/gettimesheetdata${queryParams}`,
  }),
  addAccount: {
    key: `add-account`,
    url: `/insyts-settings/addaccounts`,
  },
  getAccounts: {
    key: `get-account`,
    url: `/insyts-settings/getaccounts`,
  },
  updateAccount: {
    key: `edit-account`,
    url: `/insyts-settings/editaccounts`,
  },
  deleteAccount: {
    key: `delete-account`,
    url: `/insyts-settings/deleteaccounts`,
  },
  addFund: {
    key: "addFund",
    url: `/insyts-settings/addfunds`,          // POST
  },
  moveFund: {
    key: "moveFund",
    url: `/insyts-settings/movefunds`,         // POST
  },
  getFunds: {
    key: "getClientFunds",
    url: `/insyts-settings/getfunds`,      // GET + ?accountid=
  },
  getTransactionHistory: {
    key: "getTransactionHistory",
    url: `/insyts-settings/transactions`, // GET + ?accountid=
  },
  getClientAccountsAndMatters: {
    key: "getClientAccountsAndMatters",
    url: "/insyts-settings/clientaccountsmatters"  // ← your actual endpoint
  },
  getAllMatersList: (userId) => ({
    key: `getAllMatersList-${userId}`,
    url: `/insyts-matter/getallmatterlist?userId=${userId}`,  // GET
  }),
  getAllCurrencyList: {
    key: "getAllCurrencyList",
    url: "/insyts/timesheet/currencylist",
  },
  generateAccountReport: {
    key: "generateAccountReport",
    url: "/insyts-settings/accountreport"
  },
  getTransactionFilterList: {
    key: "getTransactionFilterList",
    url: "/insyts-settings/transactionfilterlist",
  },
  getClientMatterList: (queryParams) => ({
    key: `get-client-matter-list`,
    url: `/insyts-legal/getclientmatterlist${queryParams}`,
  }),
  deleteTimesheetClaim: {
    key: `delete-timesheet-claim`,
    url: `/insyts/timesheet/claims`,
  },
  getMatterUnbilledPaidCounts: (queryParams) => ({
    key: `get-matter-unbilled-paid-counts`,
    url: `/insyts-matter/getmatterunbilledpaidcounts${queryParams}`,
  }),
  getFundRequestFilterList: (queryParams) => ({
    key: `get-fund-request-filter-dropdown`,
    url: `/insyts-legal/getfundrequestfilterlist${queryParams}`,
  }),
  getBillingEntityList: {
    key: `get-billing-entity-list`,
    url: `/insyts-billing-entity/getbillingentity`,
  },
  getClientListForLogs: (queryParams) => ({
    key: `get-clients-logs`,
    url: `/insyts-matter/getuserclientmatter${queryParams}`,
  }),
  getRequestedMatters: (queryString) => ({
    key: ["getRequestedMatters", queryString],
    url: `${CLIENT_PORTAL_BASE_URL}insyts-legal-client-portal/getrequestedmatters?${queryString}`,
  }),
  updateRequestedMatter: {
    key: `update-requested-matter`,
    url: `${CLIENT_PORTAL_BASE_URL}insyts-legal-client-portal/approvalstatusupdate`,
  },
};

export default queryKeys;
